import PageBase from '@common/PageBase'
import VueCqrs from '@cqrs/vue-component-cqrs'
import * as q from '@DataSharing/Shares/queries'
import Component, { mixins } from 'vue-class-component'

@Component
export default class VuePageQueries extends mixins(PageBase, VueCqrs) {
	runAccessShareQueryV1(id: string)
	{
		const query = q.buildAccessShareQueryV1(id)
		this.$query(query)
	}

	runActiveSharesQueryV1(organizationUnitId: number)
	{
		const query = q.buildActiveSharesQueryV1(organizationUnitId)
		this.$query(query)
	}

	runDataShareEmailsProvidersQueryV1(organizationUnitId: string, workspaceId: string | null, projectId: string | null)
	{
		const query = q.buildDataShareEmailsProvidersQueryV1(organizationUnitId, workspaceId, projectId)
		this.$query(query)
	}

	runEmailsAndGroupsQueryV1(organizationUnitId: string, workspaceId: string | null, projectId: string | null, emailsProviderName: string)
	{
		const query = q.buildEmailsAndGroupsQueryV1(organizationUnitId, workspaceId, projectId, emailsProviderName)
		this.$query(query)
	}

	runResourceSharesQueryV1(resourceProviderName: string, resourceId: string)
	{
		const query = q.buildResourceSharesQueryV1(resourceProviderName, resourceId)
		this.$query(query)
	}

	runShareNotificationQueryV1(id: string)
	{
		const query = q.buildShareNotificationQueryV1(id)
		this.$query(query)
	}

	runShareQueryV1(resourceProviderName: string, resourceId: string, id: string)
	{
		const query = q.buildShareQueryV1(resourceProviderName, resourceId, id)
		this.$query(query)
	}

	runSharesForEmailQueryV1(email: string)
	{
		const query = q.buildSharesForEmailQueryV1(email)
		this.$query(query)
	}

}
